import Service from './Service';

class Storage extends Service {
  constructor(key) {
    super();
    this.stateKey = key;
    this.loadState();
  }
  loadState() {
    try {
      this.state = JSON.parse(localStorage.getItem(this.stateKey)) || {};
    } catch {
      this.state = {};
    }
  }
  saveState() {
    try {
      localStorage.setItem(this.stateKey, JSON.stringify(this.state));
    } catch {
      // Wrapping incase is blocked
    }
  }
  removeState() {
    try {
      localStorage.removeItem(this.stateKey);
    } catch {
      // Wrapping incase is blocked
    }
  }
}
const instances = {};
export default function LocalStorage(key) {
  if (!instances[key]) instances[key] = new Storage(key);
  return instances[key]
}
